import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()
export class RequestsCustomerService {
  newRequest: Observable<any>;
  private newRequestSubject: EventEmitter<any> = new EventEmitter();
  responseData: any;
  handleError: any;
  private toggleIt: EventEmitter<any> = new EventEmitter();
  toggleSender = this.toggleIt.asObservable();
  askToToggle(change: any) {
    this.toggleIt.next(change);
  }
  constructor(private httpClient: HttpClient, private gtn: globals.GetTokenNow) {
    this.newRequest = this.newRequestSubject.asObservable();
  }
  viewRequest(requestId) {
    return this.httpClient.get(`${globals.domain}/customer/requests/${requestId}/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  editRequest(requestId) {
    return this.httpClient.get(`${globals.domain}/customer/requests/${requestId}/edit/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  getNewRquests(data) {
    this.newRequestSubject.next(data);
  }
  listParts(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/customer/parts/list/sortBy-${sort}/${records}/${pageNumber}/`, headers)
      .pipe(map(res => res as any));
  }
  markQuotaAsRead(body) {
    return this.httpClient
      .put(`${globals.domain}/core/notifications/mark-documents-as-viewed/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
}